import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Text } from "grommet";
import * as React from "react";
import Avatar from "react-avatar";
import { useNavigate } from "react-router-dom";
import OrganizationSearch from "../organizations/OrganizationSearch";
import { Organization } from "../organizations/OrganizationStore";
import LeagueDetails from "./LeagueDetails";
import { createLeague, CreateLeagueRequest } from "./LeaguesStore";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
const xmark = <FontAwesomeIcon icon={["fad", "xmark"]}></FontAwesomeIcon>;

const CreateLeague = () => {
    let [organization, setOrganization] = React.useState({} as Organization);

    let [league, setLeague] = React.useState(new CreateLeagueRequest());

    let [isCreating, setIsCreating] = React.useState(false);

    let [error, setError] = React.useState("");

    const navigate = useNavigate();

    let create = () => {
        setIsCreating(true);
        createLeague({ ...league, organizationID: organization.id }).then(
            (result) => {
                navigate(`/leagues/${result.leagueID}`);
            },
            (error) => {
                setError(error);
            }
        );
    };

    const onChange = (updatedLeague) => {
        setLeague({ ...league, ...updatedLeague });
    };

    return (
        <div>
            <h1>Create League</h1>
            <Box>
                <OrganizationSearch onSelect={(organization) => setOrganization(organization)}></OrganizationSearch>
                <LeagueDetails league={league} isBusy={isCreating} onChange={onChange}></LeagueDetails>
                <Button primary onClick={create} disabled={isCreating || !league.name || !organization.id} label="Create"></Button>
                <Box>{error && <pre>{JSON.stringify(error, null, 2)}</pre>}</Box>
            </Box>
        </div>
    );
};

export default CreateLeague;
